import { colors, typography } from "../../../styles/theme.js";
import { useCallback, useMemo } from "react";
import { useState } from "react";

const styles = {
  container: {
    borderTop: `2px solid ${colors.background}`,
    borderBottom: `2px solid ${colors.background}`,
    padding: "12px 16px 12px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: colors.hoverAccent,
    color: colors.text,
  },
  title: {
    fontWeight: typography.fontWeight.medium,
    fontSize: typography.fontSize.base,
    color: colors.text,
    marginBottom: 4,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  artist: {
    fontSize: typography.fontSize.xs,
    color: colors.textSecondary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  button: {
    marginLeft: 12,
  },
  hoveredContainer: {
    background: colors.primaryHover,
    borderBottom: `2px solid ${colors.background}`,
    color: colors.white,
  },
  highlightContainer: {
    borderRadius: "8px",
    background: colors.secondary,
    margin: "0 -30px 0px -30px",
    textSize: typography.fontSize.lg,
    boxShadow: "0px -1px 32px 7px rgba(0,0,0,0.25)",
    zIndex: 1000,
    border: `${colors.primary} 4px solid`,
  },
  highlightText: {
    color: colors.text,
    textSize: 80,
  },
  hoveredHighlightContainer: {
    borderRadius: "8px",
    background: colors.primaryHover,
    color: colors.white,
    margin: "0 -30px 0px -30px",
    textSize: typography.fontSize.lg,
    boxShadow: "0px -1px 32px 7px rgba(0,0,0,0.25)",
    zIndex: 1000,
    textColor: colors.white,
    border: `${colors.primary} 4px solid`,
  },

  hoveredActionIcon: {
    color: colors.white,
  },
};

const PlaylistItem = ({
  song,
  index,
  highlight,
  ActionIcon,
  onActionPress,
  actionIconColor,
  endContent,
}) => {
  const [hovered, setHovered] = useState(false);

  const title = useMemo(() => {
    return song.songName.length > 30
      ? song.songName.slice(0, 30) + "..."
      : song.songName;
  }, [song.songName]);
  const artist = useMemo(() => {
    return song.artistName.length > 30
      ? song.artistName.slice(0, 30) + "..."
      : song.artistName;
  }, [song.artistName]);

  const handleMouseEnter = useCallback(() => {
    setHovered(true);
  }, [setHovered]);

  const handleMouseLeave = useCallback(() => {
    setHovered(false);
  }, [setHovered]);

  const handleCellClick = useCallback(() => {
    window.open(`https://www.youtube.com/watch?v=${song.videoId}`, "_blank");
  }, [song.videoId]);

  const handleActionPress = useCallback(
    (e) => {
      e.stopPropagation();
      onActionPress(song.id);
    },
    [onActionPress, song.id]
  );

  return (
    <div
      style={{
        ...styles.container,
        ...(!highlight &&
          !hovered && { backgroundColor: colors.secondaryBackground }),
        ...(!highlight && hovered && styles.hoveredContainer),
        ...(highlight && styles.hoveredHighlightContainer),
        // ...(highlight && !hovered && styles.highlightContainer),
        borderTop: index === 0 ? `2px solid ${colors.background}` : "none",
      }}
      onClick={handleCellClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          gap: 12,
        }}
      >
        <div
          style={{
            width: 50,
            height: 50,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 4,

            ...(highlight && { width: 80, height: 80 }),
          }}
        >
          <img
            src={`https://img.youtube.com/vi/${song.videoId}/hqdefault.jpg`}
            alt={song.songName}
            style={{
              width: "120px",
              height: "90px",
              objectFit: "cover",
              objectPosition: "center",
              filter: hovered || highlight ? "none" : " grayscale(100%)  ",
              opacity: hovered || highlight ? 1 : 0.8,
              ...(highlight && { width: 200, height: 150 }),
            }}
          />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontWeight: typography.fontWeight.medium,
              fontSize: highlight
                ? typography.fontSize.lg
                : typography.fontSize.base,
              marginBottom: 4,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </div>
          <div
            style={{
              fontSize: highlight
                ? typography.fontSize.md
                : typography.fontSize.sm,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {artist}
          </div>
        </div>
      </div>
      {endContent && (
        <div style={{ marginLeft: 12, fontSize: typography.fontSize.sm }}>
          {endContent}
        </div>
      )}
      {ActionIcon && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            padding: 12,
            // color: colors.primary,
            height: "100%",
            ...(!!hovered && styles.hoveredActionIcon),
          }}
          onClick={handleActionPress}
        >
          <ActionIcon
            color={hovered ? colors.white : actionIconColor}
            size={23}
          />
        </div>
      )}
    </div>
  );
};

export default PlaylistItem;
